module.exports = __webpack_public_path__ + "static/assets/65b4a6b4efcb1e50f0cc84030661be60.gif";